"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var calculateMiddleAngle_1 = require("./calculateMiddleAngle");
exports.calculateNewPosition = function (data, rx, ry, moveDistance) {
    var middleAngle = calculateMiddleAngle_1.calculateMiddleAngle(data.startAngle, data.endAngle);
    return [
        moveDistance * rx * Math.cos(middleAngle > Math.PI ? middleAngle : -middleAngle),
        moveDistance * ry * Math.sin(middleAngle),
    ];
};
